import globalConfig from '../config/features';

const FEATURE_FLAG_STORAGE_KEY = 'feature.flags';
const FEATURE_FLAG_PARAM_PREFIX = 'ff.';

export function getPreferredStorage() {
  const storage = window.sessionStorage;
  return {
    save: (featureFlags: Record<string, unknown>) => {
      storage.setItem(FEATURE_FLAG_STORAGE_KEY, JSON.stringify(featureFlags));
    },
    get: () => {
      const featureFlags = storage.getItem(FEATURE_FLAG_STORAGE_KEY);
      return featureFlags ? JSON.parse(featureFlags) : {};
    }
  };
}
const STORAGE = getPreferredStorage();

export function parseFeatureFlagsFromURL(query: string, config: Record<string, unknown>) {
  const parsedFeaturesMap: Record<string, unknown> = {};
  query.split('&').forEach(param => {
    const paramPair = param.split('=');
    if (
      paramPair &&
      paramPair.length === 2 &&
      decodeURIComponent(paramPair[0]).indexOf(FEATURE_FLAG_PARAM_PREFIX) === 0
    ) {
      const parsedKey = decodeURIComponent(paramPair[0]).substring(
        FEATURE_FLAG_PARAM_PREFIX.length
      );
      const parsedValue = decodeURIComponent(paramPair[1]);
      const configValue = config[parsedKey];
      // @ts-ignore
      if (configValue && configValue.flagKey) {
        // @ts-ignore
        parsedFeaturesMap[configValue.flagKey] =
          parsedValue === 'true' ? true : parsedValue === 'false' ? false : parsedValue;
      }
    }
  });
  return parsedFeaturesMap;
}

export function flattenConfig(mergedConfig: Record<string, unknown>) {
  const flattenedConfig = Object.keys(mergedConfig).reduce((merged, key) => {
    // @ts-ignore
    merged[mergedConfig[key].flagKey] = mergedConfig[key].value;
    return merged;
  }, {});
  return flattenedConfig;
}

export default function getFeatureFlagsList(query: string, config: Record<string, unknown> = {}) {
  const mergedConfig = Object.assign({}, globalConfig, config);
  const featureFlagsFromURL = parseFeatureFlagsFromURL(query, mergedConfig);
  const featuresFromStorage = STORAGE.get();
  STORAGE.save(Object.assign(featuresFromStorage, featureFlagsFromURL));
  // Global config is default, then config that was passed in, storage, then URL overrides all.
  const flattenedConfig = flattenConfig(mergedConfig);
  const mergedFeatureFlags = {
    ...flattenedConfig,
    ...featuresFromStorage,
    ...featureFlagsFromURL
  };
  return mergedFeatureFlags;
}
